module.exports = __webpack_public_path__ + "static/media/erecht24-impressum.4b5bcb9d.png";